import configAxios from 'axios';
import store from "../store";
import router from "../router";

const axios = configAxios.create({
    baseURL: "http://localhost:8080",
    headers: {
    }
});

axios.interceptors.request.use(config => {
    store.commit('beginLoading')
    return config;
});

axios.defaults.validateStatus = (status) => {
    return status >= 200 && status < 300;
};

axios.interceptors.response.use(response => {
    console.log('[Axios] Response:', response.config.url, response.status, response.data);
    return response;
}, error => {
    console.error('[Axios] Error:', error.config?.url, error.response?.status, error.response?.data || error.message);
    if (error.response?.status === 401 || error.message === 'Error: Network Error' || error.message === 'Error: Request failed with status code 401') {
        console.error('[Axios] Redirecionando para login devido a erro de autenticação');
        router.push({ name: 'Login' })
    }
    return Promise.reject(error);
});

export default axios;
